import { useContext } from 'react';
import { SystemStyleObject, Theme } from '@mui/system';
import { ProxyLoginContext } from '../contexts/ProxyLoginContext';
import {
  PROXY_BANNER_HEIGHT,
  PROXY_DIALOG_GAP,
  PROXY_DIALOG_MARGIN_TOP,
} from '../constants/labels';

/**
 * 代理モード時のダイアログ位置調整用sxを返すフック
 * バナー分のmarginTopを自動的に適用する
 * sx={[styles.dialog, proxyDialogSx]} のように配列内で使用可能
 *
 * @param options.fullHeight ダイアログが全高（maxHeight: calc(100vh - 32px) 等）の場合に true を指定する。
 *   代理モードでは marginTop でバナー分下げるため、maxHeight もバナー＋上下余白を差し引かないと
 *   下端が画面下部に密着してしまう。true 指定時のみ maxHeight を制限する（既定は従来どおり未設定）。
 */
export const useProxyDialogSx = (options?: { fullHeight?: boolean }): SystemStyleObject<Theme> => {
  const { isProxyLogin } = useContext(ProxyLoginContext);

  if (!isProxyLogin) return {};

  return {
    // ItemEditModal のように `& > .MuiDialog-container > .MuiPaper-root` と
    // 子孫セレクタを連ねてカードを整形しているダイアログがある。そちらの詳細度が
    // 高いと marginTop が打ち消され、モーダルが代理バナーにかぶってしまう（#3310）。
    // こちらもコンテナ経由で指定し、クラスを重ねて詳細度を上げて確実に勝たせる。
    '& > .MuiDialog-container > .MuiPaper-root.MuiPaper-root': {
      marginTop: PROXY_DIALOG_MARGIN_TOP,
      // 全高ダイアログのみ: バナー（PROXY_BANNER_HEIGHT）＋上下の余白を差し引いた高さに制限し、
      // 下端が画面下部に密着しないようにする。上の余白（PROXY_DIALOG_GAP）と同じ値を
      // 下にも確保し、バナー下とダイアログ下端の余白を揃える（#3310）。
      ...(options?.fullHeight
        ? { maxHeight: `calc(100vh - ${PROXY_BANNER_HEIGHT + PROXY_DIALOG_GAP * 2}px)` }
        : {}),
    },
  };
};
